
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wizard/[initiativeId]/create-start",
      function () {
        return require("private-next-pages/wizard/[initiativeId]/create-start.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wizard/[initiativeId]/create-start"])
      });
    }
  